import React from 'react';

/**
 * The one pill for "where is this in its lifecycle" — closure steps, erasure
 * tasks, app connections. Tone names, not colours, so pages say what a state
 * means and the stylesheet decides how that looks.
 *
 * Tones: success | info | warning | danger | muted.
 */
export default function StatusBadge({ tone = 'muted', className = '', children }) {
    return <span className={`ll-status ll-status--${tone} ${className}`.trim()}>{children}</span>;
}
